import { combineReducers } from "@reduxjs/toolkit";
import { authReducer } from "./authReducer";
import { dropboxReducer } from "./dropboxReducer";
import { photosReducer } from "./photosReducer";

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  dropbox: dropboxReducer,
  photos: photosReducer,
});

export default rootReducer;
